import React from "react";
import ReactionsList from "../../../../../gd-components/reactions/reactions-list/reactions-list";
import Reactions from "../../../../../model2/reaction/reactions";


export default function FieldReaction_InlineValueNotEmpty(props:any) {

    const reactions : Reactions = Reactions.initFromJson(props.value)

    const onToggleReaction = (reactionType:number) => {
        // reactions.removeMyReaction(reactionType)
        reactions.toggleMyReaction(reactionType)
        props.onChange(reactions.toJSON())
    }

    // <ReactionsList reactions={reactions} toggleReaction={onToggleReaction} className="cell-view" />

    return (
        <React.Fragment>
            <div className="ui5-field-dropdown-inline-editable w-100-percent h-100-percent" onClick={props.onClick}>
                <ReactionsList reactions={reactions} toggleReaction={onToggleReaction} />
            </div>

            {props.children}
        </React.Fragment>
    )
}
